import React from 'react';
import CSSModules from 'react-css-modules';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Badge from '../../Badge';
import Card from '../../Card';
import ClickableElement from '../../ClickableElement';
import Icon from '../../Icon';
import styles from '../index.styl';

const cardStyle = { borderRadius: '4px' };

const SurveyListButton = ({
  text,
  badge,
  disabled,
  active,
  onClick,
  className,
}) => {
  const getIcon = () => <Icon name="up-surveys-small" height={32} width={24} />;
  const getBadge = () => (
    <If condition={badge}>
      <Badge colored text={badge} />
    </If>
  );

  return (
    <div className={className}>
      <ClickableElement
        onClick={onClick}
        hoverable
        disabled={disabled}
        styleName={classNames('surveys-list-button', {
          'surveys-list-button--active': active,
          'surveys-list-button--disabled': disabled,
        })}
        className="flex flex-center"
      >
        <Card
          text={{ primary: text }}
          additionalContent={{
            left: getIcon(),
            right: getBadge(),
          }}
          className="fw6 w-100"
          style={cardStyle}
        />
      </ClickableElement>
    </div>
  );
};

SurveyListButton.propTypes = {
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.shape({
    name: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  text: PropTypes.string,
  badge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default CSSModules(SurveyListButton, styles, {
  allowMultiple: true,
});



// WEBPACK FOOTER //
// ./src/components/Surveys/SurveyListButton/index.jsx